module.exports = "<nv-react-component component=\"LearnerDashboard\"></nv-react-component>";